import dynamic from 'next/dynamic';
import React from 'react';
import LayoutComponent from '../../components/home/layouts/LayoutComponent';
import GET_COURSES_BY_TAGS from '../../gql/queries/get-courses-by-tags.gql';
import GET_ALL_COURSE_TAGS from '../../gql/queries/get-all-courses-tags.gql';
import GET_ALL_COURSE_CENTERS from '../../gql/queries/get-all-courses-centers.gql';
import { getOrganizationPropertiesByHost } from '../../utils/helpers';
import { initializeApollo } from '../../../apollo-ssr';
import { getServerSideToken } from '../../utils/auth-utils';
import GET_JSON_VARIABLE from '../../gql/queries/get-json-variable.gql';

const Home = dynamic(() => import('./home'), { ssr: true });

function HomeWrapper({ ...props }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Home {...props} />
  );
}

HomeWrapper.getLayout = function getLayout(page) {
  return (
    <LayoutComponent leftSidebarShow="1" pageTitle="Home" headerType="2" paddingClass="p-0">
      {page}
    </LayoutComponent>
  );
};

export async function getServerSideProps(context) {
  let hostname;
  if (context && context.req && context.req.headers && context.req.headers.host) {
    hostname = context.req.headers.host;
  } else {
    // Fallback if no context provided
    hostname = 'nextias.com';
  }
  const userToken = getServerSideToken(context.req);
  const apolloClient = initializeApollo(null, userToken, hostname);
  // console.log('Apollo Client Initialized inside getServerSideProps ssr test', context);

  const organizationProperties = getOrganizationPropertiesByHost(hostname);

  const { data: jsonData } = await apolloClient.query({
    query: GET_JSON_VARIABLE,
    variables: {
      name: 'defaultOfflineCenter',
      language: 'en',
    },
    errorPolicy: 'ignore',
  });

  const centerId = jsonData?.getJsonVariable?.value?.centerId || '';
  console.log('centerId', centerId);

  try {
    // Fetch courses data during SSR

    const queryPromises = [
      apolloClient.query({
        query: GET_COURSES_BY_TAGS,
        variables: {
          orgId: organizationProperties?.orgId,
          filters: [
            {
              key: 'centreId',
              value: '',
            },
            {
              key: 'tagId',
              value: '',
            },
            {
              key: 'mode',
              value: 'Online',
            },
          ],
        },
        errorPolicy: 'ignore',
      }),
      apolloClient.query({
        query: GET_COURSES_BY_TAGS,
        variables: {
          orgId: organizationProperties?.orgId,
          filters: [
            {
              key: 'centreId',
              value: centerId || '',
            },
            {
              key: 'tagId',
              value: '',
            },
            {
              key: 'mode',
              value: 'Offline',
            },
          ],
        },
        errorPolicy: 'ignore',
      }),
      apolloClient.query({
        query: GET_ALL_COURSE_TAGS,
        variables: {
          getOrganizationByIdId: organizationProperties?.orgId,
          orgId: organizationProperties?.orgId,
          page: 'home',
        },
        errorPolicy: 'ignore',
      }),
      apolloClient.query({
        query: GET_ALL_COURSE_CENTERS,
        variables: {
          getOrganizationByIdId: organizationProperties?.orgId,
        },
        errorPolicy: 'ignore',
      }),
    ];

    const queryResults = await Promise.allSettled(queryPromises);

    // Process results safely
    const [
      onlineCoursesResult,
      offlineCoursesResult,
      tagsResult,
      centersData,
    ] = queryResults;

    const initialOnlineCoursesData = onlineCoursesResult.status === 'fulfilled'
      ? onlineCoursesResult.value.data
      : null;

    const initialOfflineCoursesData = offlineCoursesResult.status === 'fulfilled'
      ? offlineCoursesResult.value.data
      : null;

    const initialTagsData = tagsResult.status === 'fulfilled'
      ? tagsResult.value.data
      : null;

    const initialCentersData = centersData.status === 'fulfilled'
      ? centersData.value.data
      : null;

    queryResults.forEach((result, index) => {
      if (result.status === 'rejected') {
        console.error(`Query ${index} failed:`, result.reason);
      }
    });

    // console.log('initialOnlineCoursesData', initialOnlineCoursesData);

    return {
      props: {
        initialOnlineCoursesData,
        initialOfflineCoursesData,
        hostname,
        initialTagsData,
        initialCentersData,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  } catch (error) {
    console.error('Error fetching courses data:', error);
    return {
      props: {
        initialOnlineCoursesData: null,
        initialOfflineCoursesData: null,
        hostname: null,
        initialTagsData: null,
        initialCentersData: null,
        apolloState: apolloClient.cache.extract(),
      },
    };
  }
}

export default HomeWrapper;
